import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a987183"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "book-history-row-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "book-history-row-wrapper",
      onClick: $setup.emitOnClickBoardHistoryRow
    }, [
      _createVNode($setup["BoardHistoryRowInfo"], { boardInfo: $props.boardInfo }, null, 8 /* PROPS */, ["boardInfo"]),
      _createCommentVNode(" <button\n        v-if=\"boardInfo.isEvaluable\"\n        class=\"service-evaluation-btn\"\n        :class=\"{ disabled: !boardInfo.isEvaluable }\"\n        type=\"button\"\n        @click=\"goToBoardEvaluation(boardInfo)\"\n      >\n        만족도 평가\n      </button> ")
    ])
  ]))
}